import { EmojiPickerButton } from './EmojiPickerButton';

export interface DiscussionComposeToolbarProps {
  onEmojiSelect: (emoji: string) => void;
  disabled?: boolean;
}

export function DiscussionComposeToolbar({
  onEmojiSelect,
  disabled = false
}: DiscussionComposeToolbarProps) {
  return (
    <div className="discussion-compose-toolbar" aria-label="Message tools">
      <div className="discussion-compose-toolbar__spacer" />
      <EmojiPickerButton onSelect={onEmojiSelect} disabled={disabled} />
    </div>
  );
}

